import { Tag, TagProps } from "primereact/tag";
import classes from "./StatusTag.module.scss";
import classNames from "classnames/bind";

export type Status =
  | "Active"
  | "Inactive"
  | "Archived"
  | "Deleted"
  | "InActive";

type StatusTagProps = {
  status: Status | string;
  severity?: TagProps["severity"];
  rounded?: boolean;
  icon?: string;
  style?: any;
};

const StatusTag: React.FC<StatusTagProps> = (props) => {
  const cx = classNames.bind(classes);

  return (
    <Tag
      value={props.status}
      className={cx(classes.statusTag, props.status)}
      severity={props.severity}
      rounded={props.rounded}
      icon={props.icon}
      style={props.style}
    />
  );
};

export default StatusTag;
